module.exports = __webpack_public_path__ + "img/26.4ff89f3e.jpg";